<template>
  <div class="grid">
    <loading
      :active="isLoadingModel"
      :can-cancel="true"
      color="#274461"
      :is-full-page="fullPage"
    ></loading>
    <Toast />
    <div class="col-12 sticky">
      <div id="custom_card" class="card">
        <div class="grid justify-content-between">
          <div class="col-12 md:col-6">
            <div
              class="flex flex-wrap align-items-center justify-content-center md:justify-content-start md:mb-0 mb-3"
            >
              <p style="color: #3f51b5; font-size: 20px; font-weight: 800">
                {{ $t("job_applications") }}
              </p>
            </div>
          </div>
          <div class="col-12 md:col-6">
            <div
              class="flex flex-wrap align-items-center justify-content-end md:justify-content-end md:mb-0 mb-3"
            >
              <Button v-if="flag==true" @click="back" class="p-button-danger" :label="$t('goback')" icon="pi pi-angle-double-left" />

              <!-- <Button
                iconPos="right"
                :label="$t('add')"
                v-tooltip.bottom="$t('add')"
                icon="pi pi-plus"
                @click="openNew"
                size="small"
                style=""
              /> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="card" id="custom_card">
        <div class="grid p-fluid">
          <div class="col-12 md:col-12">
            <div class="p-fluid formgrid grid">
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <InputText
                    format="text"
                    v-model="search_filter"
                    @input="search(1)"
                  >
                  </InputText>
                  <label>{{ $t("search_type") }}</label>
                </span>
              </div>
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <Dropdown
                    id="status"
                    v-model="status_dropdownItem"
                    :options="status_dropdownItems"
                    optionLabel="name"
                    filter
                    @change="search(1)"
                  >
                  </Dropdown>
                  <label for="status">{{ $t("status") }}</label>
                </span>
              </div>
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <Dropdown
                    id="opening"
                    v-model="opening_dropdownItem"
                    :options="opening_dropdownItems"
                    optionLabel="name"
                    filter
                    @change="search(1)"
                  >
                  </Dropdown>
                  <label for="opening">{{ $t("jobs") }}</label>
                </span>
              </div>
              <div class="field col-2 md:col-2">
                <Button
                  icon="pi pi-refresh"
                  v-tooltip.bottom="$t('refresh')"
                  @click="search(2)"
                  class="p-button-danger"
                  style=""
                />
              </div>
            </div>
          </div>
        </div>
        <DataTable
          :loading="loading"
          ref="dt"
          :lazy="true"
          :totalRecords="totalRecords"
          :paginator="true"
          :value="products"
          v-model:selection="selectedProducts"
          :dataKey="columns[0]"
          :rows="limit"
          :filters="filters"
          @page="onPage($event)"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="PerPageOptions"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          responsiveLayout="scroll"
          style="font-size: 12px"
          :rowHover="true"
          showGridlines
        >
          <template #empty>
            <b style="text-align: center">{{ $t("no_rec") }}</b>
          </template>
          <template #header>
            <div style="text-align: right; font-weight: bold">
              <span>{{ $t("total_applications") }}:</span>{{ totalRecords }}
            </div>
          </template>
          <Column
            :header="$t('status')"
            style="min-width: 8rem; text-align: center"
            :field="columns[5]"
          >
            <template #body="{ data }">
              <span v-if="data.status == 'Applied' || data.status == 'Applied'"
                ><badge
                  class="p-button-success"
                  value="Applied"
                  severity="success"
                ></badge
              ></span>
              <span v-else-if="data.status == 'In Active' || data.status == 'Inactive'"
                ><badge
                  class="p-button-warning"
                  value="In Active"
                  severity="warning"
                ></badge
              ></span>
              <span v-else-if="data.status == 'Deleted' || data.status == 'Deleted'"
                ><badge
                  class="p-button-danger"
                  value="Deleted"
                  severity="danger"
                ></badge
              ></span>
              <span v-else>-</span>
            </template>
          </Column>
          <Column :header="$t('mobile_no')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.mobile_no }}
            </template>
          </Column>
           <Column :header="$t('job_title')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.job_details?.[0]?.job_title ?? '' }}
            </template>
          </Column>
          <Column :header="$t('applicant_name')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.worker_details?.[0]?.worker_name ?? '' }}
            </template>
          </Column>
          <Column :header="$t('pan_number')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.worker_details?.[0]?.PAN_Number ?? '' }}
              
            </template>
          </Column>
          <Column :header="$t('aadhaar_number')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.worker_details?.[0]?.Aadhaar_Number ?? '' }}
             
            </template>
          </Column>
          
          <Column :header="$t('applied_date')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ dateFormatDMY(data.applied_date) }}
            </template>
          </Column>
         
          
          <!-- <Column :header="$t('action')" headerStyle="min-width:5rem;">
            <template #body="slotProps">
              <Button
                v-if="slotProps.data.status != Deleted"
                icon="pi pi-pencil"
                title="$t('edit_client')"
                v-tooltip.bottom="$t('edit')"
                class="p-button-rounded p-button-success mr-2"
                @click="editProduct(slotProps.data)"
                style=""
              />
              <Button
                v-if="slotProps.data.status != Deleted"
                icon="pi pi-trash"
                v-tooltip.bottom="$t('delete')"
                class="p-button-rounded p-button-danger mt-2"
                @click="confirmDeleteProduct(slotProps.data)"
                style=""
              />
            </template>
          </Column> -->
        </DataTable>
      </div>
    </div>
    <Dialog
      v-model:visible="productDialog"
      :breakpoints="{ '960px': '75vw' }"
      :style="{ width: '35vw' }"
      :header="$t('asset_type')"
      :modal="true"
      position="top"
    >
      <div class="col-12">
        <div class="p-fluid formgrid grid" style="margin-top: 2%">
          <div class="field col-12 md:col-12" style="margin-top: 3%">
            <span class="p-float-label">
              <InputText
                id="ticket_title"
                type="text"
                v-model="product.asset_type"
              />
              <label for="name">{{ $t("asset_type") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-12" style="margin-top: 3%">
            <span class="p-float-label">
              <InputText
                id="ticket_title"
                type="text"
                v-model="product.asset_type_mr"
              />
              <label for="name">{{ $t("asset_type_mr") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-12" style="margin-top: 3%">
            <span class="p-float-label">
              <InputText
                id="rate_of_depreciation"
                type="number"
                v-model="product.rate_of_depreciation"
              />
              <label for="name">{{ $t("rate_of_depreciation") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-12" style="margin-top: 3%">
            <span class="p-float-label">
              <Textarea
                rows="6"
                id="remarks"
                type="text"
                v-model="product.remarks"
              />
              <label for="name">{{ $t("remarks") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-12" style="margin-top: 3%">
            <span class="p-float-label">
              <Dropdown
                id="status"
                v-model="addeditstatus_dropdownItem"
                :options="status_dropdownItems"
                optionLabel="name"
                filter
                :disabled="!product._id"
              >
              </Dropdown>
              <label for="status">{{ $t("status") }}</label>
            </span>
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          :label="$t('save')"
          @click="save_event"
          icon="pi pi-check"
          class="p-button-success"
        />
      </template>
    </Dialog>
    <Dialog
      v-model:visible="deleteProductDialog"
      :style="{ width: '450px' }"
      :header="$t('Confirm')"
      :modal="true"
    >
      <div class="flex align-items-center justify-content-center">
        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
        <span v-if="product"
          >{{ $t("delete_msg") }}<b>{{ product.asset_type }}</b
          >?</span
        >
      </div>
      <template #footer>
        <Button
          :label="$t('no')"
          icon="pi pi-times"
          class="p-button-text"
          @click="deleteProductDialog = false"
        />
        <Button
          :label="$t('yes')"
          icon="pi pi-check"
          class="p-button-text"
          @click="deleteevent"
        />
      </template>
    </Dialog>
  </div>
</template>
  <script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import apis from "@/apis";
import axios from "axios";
export default {
  data() {
    return {
      flag:false,
      opening_dropdownItems: [],
      opening_dropdownItem: null,


      status_dropdownItems: [
        { name: "Applied", value: "Applied" },
        { name: "In Active", value: "In Active" },
        { name: "Deleted", value: "Deleted" },
      ],
      status_dropdownItem: null,
      addeditstatus_dropdownItem: null,
      search_filter: "",
      user_key: "",
      page_no: 1,
      isLoading: false,
      PerPageOptions: [10, 50, 100],
      isLoadingModel: false,
      loading: false,
      fullPage: true,
      products: null,
      productDialog: false,
      deleteProductDialog: false,
      deleteProductsDialog: false,
      lazyParams: {},
      product: {},
      selectedProducts: null,
      filters: {},
      offset: 1,
      limit: 10,
      columns: [],
      pageno: 1,
      submitted: false,
      totalRecords: 0,
      id: "",
      localInfo: "",
    };
  },
  productService: null,
  async created() {
    this.productService = new ProductService();
    this.initFilters();
    this.user_key = localStorage.getItem("user_type");
  },
  async mounted() 
  {
      await this.jobOpening();
     if (localStorage.getItem("product")) 
     {  
        this.localInfo = await JSON.parse(localStorage.getItem("product"));
        localStorage.setItem("product", "");
        
        this.flag = true;
        if (this.localInfo) 
            {
                this.opening_dropdownItem={name:this.localInfo['job_title'],value:this.localInfo['_id']};
            }
     }

    this.id = this.$route.params.id;
    this.lazyParams = {
      first: 0,
      rows: this.limit,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    };
    if (this.totalRecords == 0) {
      await this.get_count();
    }
    await this.get_list();
  },
  watch: {
    currentLocale() {

    },
    async $route() {
      this.products = [];
      this.columns = [];
      this.totalRecords = 0;
      this.id = this.$route.params.id;
      if (this.id) {
        await this.get_count();
        this.get_list();
      }
    },
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
  },
  methods: {
    back() {
            this.$router.push({
                name: "JobOpening",
            });
        },
    async jobOpening() {
      var data = {
        client_id: localStorage.getItem("client_id"),
        status: "Active",
        search: "",
        count: false,
      };
      var promise = apis.ListJobOpenings(data, this.id);
      promise.then((response) => {
          const temp = response.data.data;
          this.opening_dropdownItems = temp.map(item => ({
            name: item.job_title,
            value: item._id
            }));

            
      });
      
    },
    dateFormatDMY(inputDate) {
      var postdate = inputDate;
      if (inputDate) {
        inputDate = new Date(inputDate);
        if (inputDate.toString() == "NaN-NaN-NaN") {
          return postdate;
        } else {
          let date = ("0" + inputDate.getDate()).slice(-2);
          // current month
          let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
          // current year
          let year = inputDate.getFullYear();
          if (date.toString() == "aN") {
            return postdate;
          } else {
            return date + "/" + month + "/" + year;
          }
        }
      } else {
        return "";
      }
    },
    async save_event() {
      if (!this.product.asset_type) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_asset_type"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.asset_type_mr) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_asset_type_mr"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.rate_of_depreciation) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_rate_of_depreciation"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.remarks) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_remarks"),
          life: 3000,
        });
        return false;
      }
      if (!this.addeditstatus_dropdownItem) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_status"),
          life: 3000,
        });
        return false;
      }
      var details = {};
      if (this.product._id) {
        details = {
          _id: this.product._id,
          asset_type: this.product.asset_type,
          asset_type_mr: this.product.asset_type_mr,
          remarks: this.product.remarks,
          rate_of_depreciation: this.product.rate_of_depreciation.toString(),
          updated_by: localStorage.getItem("id"),
          status: this.addeditstatus_dropdownItem?.value,
          lang: this.$i18n.locale,
        };
        var promise = apis.updateAssetType(details);
      } else {
        details = {
          asset_type: this.product.asset_type,
          asset_type_mr: this.product.asset_type_mr,
          remarks: this.product.remarks,
          rate_of_depreciation: this.product.rate_of_depreciation.toString(),
          created_by: localStorage.getItem("id"),
          status: this.addeditstatus_dropdownItem?.value,
          client_id: localStorage.getItem("client_id"),
          lang: this.$i18n.locale,
        };
        var promise = apis.createAssetType(details);
      }
      this.isLoadingModel = true;
      promise.then((response) => {
        this.isLoadingModel = false;
        if (response.data.status == true) {
          this.$toast.add({
            severity: "success",
            summary: "success",
            detail: response.data.message,
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: response.data.message,
            life: 3000,
          });
        }
        this.productDialog = false;
        this.get_list();
        this.get_count();
      });
    },
    async search(count) {
      if (count == 2) {
        this.search_filter = "";
        this.status_dropdownItem = null;
        this.opening_dropdownItem = null;
      }
      await this.get_list();
      await this.get_count();
    },
    async onPage(event) {
      this.lazyParams = event;
      this.page_no = event.page + 1;
      this.limit = event.rows;
      // console.log(event);
      //  await this.get_count();
      if (this.totalRecords > 0) {
        this.get_list();
      }
    },
    get_count: function () {
      var data = {
        //client_id: localStorage.getItem("client_id"),
        status: this.status_dropdownItem?.value,
        search: this.search_filter,
        count: true,
        job_id:this.opening_dropdownItem?.value
        //AsOnDate: "",
      };
      this.loading = true;
      var promise = apis.ListJobApplications(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.totalRecords = response.data.data;
        if (this.totalRecords > 100) {
          this.PerPageOptions.push(this.totalRecords);
        }
        //alert(this.totalRecords);
      });
      console.log(data);
    },
    get_list: function () {
      var data = {
        //client_id: localStorage.getItem("client_id"),
        status: this.status_dropdownItem?.value,
        search: this.search_filter,
        count: false,
        page_no: this.page_no,
        limit: this.limit,
        job_id:this.opening_dropdownItem?.value
        //AsOnDate: "",
      };
      this.loading = true;
      var promise = apis.ListJobApplications(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.products = response.data.data;
        console.log(this.products[0]);
        if (this.columns.length == 0) {
          if (this.products.length > 0) {
            this.columns = Object.keys(this.products[0]);
          }
        }
      });
      console.log(data);
    },
    openNew() {
      this.product = {};
      this.submitted = false;
      this.productDialog = true;
      this.addeditstatus_dropdownItem = { name: "Active", value: "Active" };
    },
    async editProduct(product) {
      this.file_attachment = "";
      this.product = { ...product };
      this.addeditstatus_dropdownItem = null;
      if (this.product.status) 
      {
        this.addeditstatus_dropdownItem = {
          name: this.product.status,
          value: this.product.status,
        };
      }
      this.productDialog = true;
    },
    confirmDeleteProduct(product) {
      this.product = product;
      this.deleteProductDialog = true;
    },
    deleteevent() {
      if (this.product._id) {
        var data = {
          _id: this.product._id,
          asset_type: this.product.asset_type,
          asset_type_mr: this.product.asset_type_mr,
          remarks: this.product.remarks,
          rate_of_depreciation: this.product.rate_of_depreciation.toString(),
          updated_by: localStorage.getItem("id"),
          status: 'Deleted',
          lang: this.$i18n.locale,
        };
        this.isLoadingModel = true;
        var promise = apis.updateAssetType(data);
        promise.then((responseapi) => {
          this.isLoadingModel = false;
          if (responseapi.data.status == true) {
            this.$toast.add({
              severity: "success", // success, info, warn, error
              summary: this.$t("success"),
              detail: responseapi.data.message,
              life: 3000, // Toast disappears after 3 seconds
            });
            this.deleteProductDialog = false;
            this.get_list();
            this.get_count();
          } else {
            this.$swal("error to Delete Asset Type");
          }
        });
      }
    },
    async exportCSV() {
      this.limit = this.totalRecords;
      this.get_list();
      await this.$refs.dt.exportCSV();
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
  components: {},
};
</script>
  <style scoped lang="scss">
@import "../assets/demo/badges.scss";
</style>
  